import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { Title, Paragraph, Chip } from 'react-native-paper';

const Section = ({ title, children }) => (
  <View style={styles.section}>
    <Title style={styles.sectionTitle}>{title}</Title>
    <View style={styles.divider} />
    <View style={styles.sectionBody}>{children}</View>
  </View>
);

export default function EditorialContent() {
  const today = new Date();
  const formattedDate = today.toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View>
          <Text style={styles.kicker}>Editörden</Text>
          <Title style={styles.title}>Şamata Play Günlük Akış</Title>
          <Paragraph style={styles.date}>Güncelleme: {formattedDate}</Paragraph>
        </View>
        <View style={styles.chipRow}>
          <Chip compact style={styles.chip} textStyle={styles.chipText}>Radyo</Chip>
          <Chip compact style={styles.chip} textStyle={styles.chipText}>Oyun</Chip>
          <Chip compact style={styles.chip} textStyle={styles.chipText}>Topluluk</Chip>
          <Chip compact style={styles.chip} textStyle={styles.chipText}>Editoryal</Chip>
        </View>
      </View>

      <Section title="Radyo Radar">
        <Paragraph style={styles.paragraph}>
          Sabah enerjisi için Türkçe Pop kanallarında yeni listeler yayında. Akşam saatlerinde nostalji ve arabesk
          kuşaklarını öne çıkarıyoruz; “En Son Dinlenenler” de anlık olarak güncelleniyor. Canlı yayınlarda kopma
          yaşamamanız için arka planda iki farklı stream sağlayıcısına otomatik geçiş aktif.
        </Paragraph>
        <Paragraph style={styles.paragraph}>
          Haftanın öne çıkan istasyonları:
        </Paragraph>
        <View style={styles.bulletList}>
          <Text style={styles.bullet}>• “Gece Modu” — lo-fi ve chill mix, düşük veri modu açık.</Text>
          <Text style={styles.bullet}>• “Şamata Pop” — yeni release listesi, yüksek kalite stream.</Text>
          <Text style={styles.bullet}>• “Retro 90” — kaset tonlu EQ ile nostalji yayını.</Text>
        </View>
      </Section>

      <Section title="Oyun Köşesi">
        <Paragraph style={styles.paragraph}>
          Pişti, UNO ve Batak odalarında hile karşıtı sayaç ve bağlantı gecikmesini ölçen ping göstergesi eklendi.
          Oyun lobilerinde minimum gecikme için en yakın bölge otomatik seçiliyor; manuel değiştirmek isterseniz
          “Oyun Seç” menüsünden bölgeyi güncelleyebilirsiniz.
        </Paragraph>
        <Paragraph style={styles.paragraph}>
          İpucu: Kart oyunlarına yeni başlayanlar için “Yeni Oyuncu” rozetli odalarda eşleşme yumuşatıldı, böylece
          agresif oyuncularla aynı masaya düşme ihtimaliniz azalır.
        </Paragraph>
      </Section>

      <Section title="Topluluk Güvenliği">
        <Paragraph style={styles.paragraph}>
          Sohbet mesajları anlık filtreyle denetleniyor, kalıcı olarak saklanmıyor. Taciz bildirimi alan hesaplar
          uyarı alıyor; tekrarında odadan otomatik uzaklaştırma devreye giriyor. Profil fotoğrafları yalnızca cihazınızda
          tutuluyor ve dışarıya paylaşılmıyor.
        </Paragraph>
        <Paragraph style={styles.paragraph}>
          Bildirim panelinde “Topluluk Rehberi”ni okuyarak güvenli sohbet ipuçlarına ulaşabilirsiniz. Görüntülü görüşme
          veya dosya paylaşımı bulunmuyor; amaç odaklı ve temiz bir sohbet deneyimi.
        </Paragraph>
      </Section>

      <Section title="Haftanın Hikâyesi">
        <Paragraph style={styles.paragraph}>
          “Gece Modu” listesini dinlerken chat’te tanışan iki kullanıcı, her akşam aynı saatte aynı istasyonda buluşup
          UNO oynuyor. Bu hafta 30. maçlarını tamamladılar; kaybeden taraf kazanana favori şarkısını çalıyor. Topluluk
          odalarında bu tür küçük ritüelleri paylaşmanız için özel bir başlık açtık.
        </Paragraph>
      </Section>

      <Section title="Editörün Seçimi">
        <Paragraph style={styles.paragraph}>
          Yerli Pop için “Şamata Pop”u, Yabancı Pop için “Foreign Hits” karışımını öneriyoruz. Dinlerken “Birlikte Dinle”
          butonuyla sohbet odasına geçip aynı anda müzik ve sohbeti deneyimleyebilirsiniz. Çalma sırasında bağlantı
          düşerse geri yükleme özelliği son dinlenen stream’e 3 saniye içinde yeniden bağlanır.
        </Paragraph>
      </Section>

      <Section title="Kısa Rehber: Daha Az Veri Tüketimi">
        <View style={styles.bulletList}>
          <Text style={styles.bullet}>• Düşük veri modu açıkken yayınlar otomatik 64-96 kbps’e iner.</Text>
          <Text style={styles.bullet}>• Arka planda çalarken ekran parlaklığını azaltmak batarya ve veri kullanımını düşürür.</Text>
          <Text style={styles.bullet}>• Hızlı ağ geçişi: Wi‑Fi’dan hücresel ağa düşüşte stream otomatik yeniden başlar.</Text>
        </View>
      </Section>

      <Section title="Arama Odaklı İpuçları (SEO)">
        <Paragraph style={styles.paragraph}>
          Şamata Play, “canlı radyo dinle”, “Türkçe pop radyo”, “yabancı pop radyo”, “online kart oyunları”
          (Pişti, UNO, Batak), “arkadaşlarla sohbet” ve “ücretsiz müzik dinle” gibi aramalar için optimize edildi.
          Kendi listelerinizi kaydedip “Birlikte Dinle” ile sohbet odasına geçebilirsiniz. Tüm yayınlar HTTPS
          üzerinden sunulur, karanlık tema varsayılan gelir.
        </Paragraph>
        <View style={styles.bulletList}>
          <Text style={styles.bullet}>• “Canlı radyo dinle” → hızlı açılan öncelikli istasyonlar.</Text>
          <Text style={styles.bullet}>• “Türkçe pop radyo” / “Yabancı pop radyo” → Top listeler oynatılabilir.</Text>
          <Text style={styles.bullet}>• “UNO oyna”, “Pişti oyna”, “Batak oyna” → oyun lobileri, sohbetle entegre.</Text>
          <Text style={styles.bullet}>• “Sohbet et, müzik dinle” → Birlikte Dinle akışı ve oda güvenliği rehberi.</Text>
        </View>
      </Section>

      <Section title="Mini SSS (Güncel)">
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Şarkı sözleri geliyor mu?</Text>
          <Text style={styles.answer}>Lisanslı sözler için görüşmeler sürüyor; şimdilik şarkı bilgisi ve kapak görseli gösteriyoruz.</Text>
        </View>
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Reklamlar müziği kesiyor mu?</Text>
          <Text style={styles.answer}>AdSense reklamları içerik alanında, stream’i kesmez. Overlay kullanmıyoruz.</Text>
        </View>
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Oda raporu nasıl gönderilir?</Text>
          <Text style={styles.answer}>Sohbet penceresinde “Şikayet et” ile moderasyon ekibine iletebilirsiniz.</Text>
        </View>
      </Section>

      <Section title="Sık Sorulanlar">
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Radyo kartları neden yukarıda kalıyor?</Text>
          <Text style={styles.answer}>Hızlı erişim ve kesintisiz müzik için ana kartlar daima sayfanın üst bölümünde tutuluyor.</Text>
        </View>
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Veri kullanımı çok mu?</Text>
          <Text style={styles.answer}>Düşük veri modunda yayınlar optimize ediliyor; lo-fi listeleri minimum bitrate ile akıyor.</Text>
        </View>
        <View style={styles.qaBlock}>
          <Text style={styles.question}>Oyunlarda gecikme olursa?</Text>
          <Text style={styles.answer}>Ping 200 ms üzerine çıkarsa bölge otomatik değiştiriliyor; manuel seçim de mümkün.</Text>
        </View>
      </Section>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 32,
    marginBottom: 48,
    padding: 16,
    backgroundColor: '#0f0f0f',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#1f1f1f',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 16,
  },
  kicker: {
    color: '#8bc6ff',
    fontSize: 13,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  title: {
    color: '#ffffff',
    fontSize: 24,
    marginTop: 4,
    marginBottom: 2,
  },
  date: {
    color: '#9aa4b5',
    fontSize: 13,
    marginTop: 4,
  },
  chipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  chip: {
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(255,255,255,0.12)',
    borderWidth: 1,
  },
  chipText: {
    color: '#e8f0ff',
    fontSize: 13,
    fontWeight: '600',
  },
  section: {
    marginTop: 12,
  },
  sectionTitle: {
    color: '#ffffff',
    fontSize: 18,
    marginBottom: 4,
  },
  divider: {
    height: 1,
    backgroundColor: '#1f1f1f',
    marginVertical: 8,
  },
  sectionBody: {
    gap: 10,
  },
  paragraph: {
    color: '#e0e6f0',
    lineHeight: 22,
    fontSize: 15,
  },
  bulletList: {
    gap: 6,
    marginTop: 4,
  },
  bullet: {
    color: '#d4dbe7',
    lineHeight: 22,
    fontSize: 15,
  },
  qaBlock: {
    padding: 12,
    backgroundColor: '#121212',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#1f1f1f',
    marginBottom: 8,
  },
  question: {
    color: '#c7d7ff',
    fontSize: 15,
    fontWeight: '700',
    marginBottom: 4,
  },
  answer: {
    color: '#e0e6f0',
    fontSize: 14,
    lineHeight: 21,
  },
});

